import { axiosInstance } from "../../../../Services";

export const fetchCardHistory = async (cardId) => {
    try {
      const res = await axiosInstance.get(`/mmhboard/cards/history/${cardId}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
  